import { Accordion, AccordionDetails, AccordionSummary, Alert, alpha, Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../../contexts/user-context/user-context';
import LoginForm from './login-form';
import ResetPasswordForm from './reset-password-form';
import { OrgSettingsContext } from '../../contexts/org-settings-context';
import axios from 'axios';
import { Organisation } from '../../interfaces/delivery-company/orders';
import { API_ENDPOINT } from '../../configurations/global.config';
import { delay } from 'lodash';
import { DomainForcedOrganisationContext } from '../../contexts/domain-forced-organisation-context';
import { InfoOutlined } from '@mui/icons-material';

type AuthAction = 'signin' | 'signup' | 'reset';

interface AuthenticationProps {
  mode: AuthAction;
}

function Authentication({ mode }: AuthenticationProps) {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { color } = useContext(OrgSettingsContext);
  const theme = useTheme();
  const { org } = useParams();
  const {setColor} = useContext(OrgSettingsContext)
  const [searchParams] = useSearchParams();

  const { forcedOrganisation, isLoading } = useContext(DomainForcedOrganisationContext);

  useEffect(() => {
    if (user) {
      const redirectTo = searchParams.get('redirect_to');
      if (redirectTo && redirectTo !== '/') {
        navigate(redirectTo, { replace: true });
      } else {
        navigate('/');
      }
    }
  }, [user, navigate, searchParams]);

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        overflow: 'hidden',
        background: `linear-gradient(to bottom,rgb(255, 255, 255), ${alpha(color, 0.18)})` 
      }}
    >
      {/* Watermark Logo Background */}
    
      {/* Content Container */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: 480,
          px: 2,
        }}
      >
        {isLoading ? <Box height={"400px"} width={"100%"} display={"flex"} justifyContent={"center"} alignItems={"center"}><CircularProgress /> </Box> :
          <>
        {/* Small Logo at Top */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 4,
            '& img': {
              height: 100,
              width: 'auto',
            }
          }}
        >
          <img 
            src={forcedOrganisation ? forcedOrganisation.logoUrl :  "/main-logo.png"} 
            alt="Company Logo" 
          />
        </Box>
            {/* Auth Form */}
            {mode === 'signin' && <LoginForm />}
            {mode === 'reset' && <ResetPasswordForm />}
          </>
        }

        
      </Box>
    </Box>
  );
}

export default Authentication;